"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const QuadTermUtil_1 = require("./lib/QuadTermUtil");
exports.collectNamedTerms = QuadTermUtil_1.collectNamedTerms;
exports.everyTerms = QuadTermUtil_1.everyTerms;
exports.filterQuadTermNames = QuadTermUtil_1.filterQuadTermNames;
exports.filterTerms = QuadTermUtil_1.filterTerms;
exports.forEachTerms = QuadTermUtil_1.forEachTerms;
exports.getNamedTerms = QuadTermUtil_1.getNamedTerms;
exports.getTerms = QuadTermUtil_1.getTerms;
exports.mapTerms = QuadTermUtil_1.mapTerms;
exports.matchPattern = QuadTermUtil_1.matchPattern;
exports.matchPatternComplete = QuadTermUtil_1.matchPatternComplete;
exports.QUAD_TERM_NAMES = QuadTermUtil_1.QUAD_TERM_NAMES;
exports.reduceTerms = QuadTermUtil_1.reduceTerms;
exports.someTerms = QuadTermUtil_1.someTerms;
exports.TRIPLE_TERM_NAMES = QuadTermUtil_1.TRIPLE_TERM_NAMES;
const TermUtil_1 = require("./lib/TermUtil");
exports.getBlankNodes = TermUtil_1.getBlankNodes;
exports.getDefaultGraphs = TermUtil_1.getDefaultGraphs;
exports.getLiterals = TermUtil_1.getLiterals;
exports.getNamedNodes = TermUtil_1.getNamedNodes;
exports.getTermsOfType = TermUtil_1.getTermsOfType;
exports.getVariables = TermUtil_1.getVariables;
exports.TERM_TYPES = TermUtil_1.TERM_TYPES;
exports.uniqTerms = TermUtil_1.uniqTerms;
//# sourceMappingURL=index.js.map